import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    token: String,
    filename: {
      type: String,
      default: "unspik_token.txt"
    }
  }

  download() {
    const blob = new Blob([this.tokenValue], { type: "text/plain" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = this.filenameValue

    // trigger the download
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }
}
